@if (loaded) {
  @if (showIsStartingAt) {
    <span class="starting-at">
      {{ 'FRONTEND.STORE.STARTING_AT' | translate }}
    </span>
  }
  @if (hasVerifiedContract && billedProduct) {
    <div>
      @if (isFlatPrice$ | async) {
        <div
          class="price-container"
          >
          <div class="price">
            {{ (pricingTierData$ | async)[0]?.priceStringForTier }}
          </div>
        </div>
      } @else {
        @if (isFirstTierFree$ | async) {
          <div class="starting-at-caption">Starting at</div>
          {{ 'FRONTEND.STORE.FREE' | translate }}
          <mat-icon
            class="tooltip-icon"
            (mouseenter)="itemInfoIconEnter()"
            (mouseleave)="itemInfoIconLeave()"
            [glxyPopover]="pricingPopover"
            >
            info_outline
          </mat-icon>
          <glxy-popover
            #pricingPopover
            [isOpen]="showPricingPopover"
            [hasArrow]="true"
            [positions]="[]"
            [padding]="'large'"
            [maxWidth]="'auto'"
            >
            <div class="pricing-popover-content">
              <div class="discounts-title">
                {{
                'FRONTEND.TABLE_PRICING.WHOLESALE_PRICING_INFORMATION'
                | translate
                }}
              </div>
              <div class="popover-price-container">
                @for (tier of pricingTierData$ | async; track tier) {
                  <div
                    class="pricing-tier"
                    >
                    <div class="pricing-tier__range">
                      {{ tier.pricingTierString }}
                    </div>
                    <div class="pricing-tier__price">
                      {{ tier.priceStringForTier }}
                    </div>
                  </div>
                }
                @if (billedProduct?.setupFee > 0) {
                  <div class="pricing-tier">
                    <div class="pricing-tier__range"></div>
                    <div class="pricing-tier__price">
                      +
                      {{
                      billedProduct.setupFee
                      | price$: billedProduct.currency
                      | async
                      }}
                      {{ setupFeeString$ | async }}
                    </div>
                  </div>
                }
              </div>
              @if (discounts$ | async; as discounts) {
                <div class="discounts">
                  @if (discounts.length) {
                    <div>
                      <span class="discounts-title">
                        {{ 'FRONTEND.TABLE_PRICING.ACTIVE_DISCOUNTS' | translate }}
                      </span>
                    </div>
                  }
                  <ul class="discount-list">
                    @for (disc of discounts; track disc) {
                      <li>
                        {{ disc | formatDiscount: $safeNavigationMigration(billedProduct?.currency) }}
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          </glxy-popover>
        } @else {
          <div class="price-container--tiered">
            @for (tier of pricingTierData$ | async; track tier) {
              <div
                class="pricing-tier"
                >
                <div class="pricing-tier__range">{{ tier.pricingTierString }}</div>
                <div class="pricing-tier__price">
                  {{ tier.priceStringForTier }}
                </div>
              </div>
            }
            @if (billedProduct?.setupFee > 0) {
              <div class="pricing-tier">
                <div class="pricing-tier__range"></div>
                <div class="pricing-tier__price">
                  +
                  {{
                  billedProduct.setupFee | price$: billedProduct.currency | async
                  }}
                  {{ setupFeeString$ | async }}
                </div>
              </div>
            }
          </div>
        }
      }
      @if (billedProduct?.setupFee > 0 && isFlatPrice$ | async) {
        <div
          class="setupFee"
          >
          + {{ billedProduct.setupFee | price$: billedProduct.currency | async }}
          {{ setupFeeString$ | async }}
        </div>
      }
      @if (
        billedProduct &&
        billedProduct.commitment &&
        billedProduct.commitment.initial > 1
        ) {
        <div
          class="commitment"
          >
          {{ commitmentMessage$ | async }}
        </div>
      }
    </div>
  } @else {
    <div class="gray-font">
      @if (shouldContactSales$ | async) {
        {{ 'FRONTEND.STORE.CONTACT_SALES' | translate }}
      } @else {
        @if (isFree$ | async) {
          {{ 'FRONTEND.STORE.FREE' | translate }}
        } @else {
          @if (priceData$ | async; as priceDatas) {
            @if (showAllPrices) {
              @for (priceData of priceDatas; track priceData; let first = $first) {
                @if (first) {
                  <span
                    [ngClass]="{ first: priceDatas.length > 1 }"
                    >
                    {{ priceData.priceStringForPricingWithFrequency }}
                  </span>
                }
                @if (!first) {
                  <span>
                    + {{ priceData.priceStringForPricingWithFrequency }}
                  </span>
                }
              }
            }
            @if (!showAllPrices) {
              {{ priceDatas[0].priceStringForPricingWithFrequency }}
            }
          }
          @if (billedProduct?.setupFee > 0) {
            <div class="setupFee">
              +
              {{
              billedProduct.setupFee | price$: billedProduct.currency | async
              }}
              {{ setupFeeString$ | async }}
            </div>
          }
          @if (
            billedProduct &&
            billedProduct.commitment &&
            billedProduct.commitment.initial > 1
            ) {
            <div
              class="commitment"
              >
              {{ commitmentMessage$ | async }}
            </div>
          }
        }
      }
    </div>
  }
} @else {
  <div class="stencil-pricing stencil-shimmer"></div>
}
